module.exports = __webpack_public_path__ + "static/media/1031 Video Script Draft - 6-7-2021_1622991527574.3bd8a9e6.cm edits";